export default {
  SET_ALIADOS (state, aliados) {
    state.aliados = aliados
  },
  ID_ALIADO_MODIFICADO (state, id) {
    state.idAliadoModificado = id
  }
}
